import { render, staticRenderFns } from "./CsList.vue?vue&type=template&id=6bfa2a3b&"
import script from "./CsList.vue?vue&type=script&lang=ts&"
export * from "./CsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports